import { TipoProcedimentoEnum } from 'graphql/types.generated'
import { useProcedimentoAutomatico } from 'hooks/procedimento-automatico/useProcedimentoAutomatico'
import { dateAsYyyyMmDd } from 'util/date/formatDate'
import { MetaPath } from 'util/metaPath'

import { ProcedimentoSigtapField } from '../detail/soap/finalizacao/components/ProcedimentoSigtapField'
import { CidadaoAtendimento } from '../types/CidadaoAtendimento'
import { ProcedimentosEscutaInicial } from './model-escutaInicial'

interface IntervencoesProcedimentosEscutaInicialFieldProps {
  name: MetaPath<ProcedimentosEscutaInicial>
  cidadao: CidadaoAtendimento
  dataAtendimento: Date
}

export function IntervencoesProcedimentosEscutaInicialField(
  props: Readonly<IntervencoesProcedimentosEscutaInicialFieldProps>
) {
  const { name, cidadao, dataAtendimento } = props

  const { removeProcedimentoAutomatico } = useProcedimentoAutomatico({
    nameProcedimentos: name.procedimentosSigtap,
    nameCodigosProcedimentosAutomaticosExcluidos: name.codigosProcedimentosAutomaticosExcluidos,
  })

  return (
    <ProcedimentoSigtapField
      name={name.procedimentosSigtap}
      handleRemoveProcedimentoAutomatico={removeProcedimentoAutomatico}
      cidadao={cidadao}
      tipoProcedimento={TipoProcedimentoEnum.CLINICO}
      label='SIGTAP'
      dataAtendimento={dateAsYyyyMmDd(dataAtendimento)}
    />
  )
}
